import { PersonalAdminSpace } from './components/PersonalAdminSpace';
import { EchoImportsProvider } from './components/training/EchoImportStatus';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useState, useEffect, useCallback, lazy, Suspense } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MainLayout } from './layouts/MainLayout';
import { LoginPage } from './pages/LoginPage';
import { OAuthCallback } from './pages/OAuthCallback';
import { TeamSelectionPage } from './pages/TeamSelectionPage';
const NewsPage = lazy(() => import('./pages/NewsPage').then(m => ({ default: m.NewsPage })));
const AdminNewsPage = lazy(() => import('./pages/admin/AdminNewsPage').then(m => ({ default: m.AdminNewsPage })));
const ProsPage = lazy(() => import('./pages/ProsPage').then(m => ({ default: m.ProsPage })));
const ScoutPage = lazy(() => import('./pages/ScoutPage').then(m => ({ default: m.ScoutPage })));
const DashboardPage = lazy(() => import('./pages/DashboardPage').then(m => ({ default: m.DashboardPage })));
const ProfilePage = lazy(() => import('./pages/ProfilePage').then(m => ({ default: m.ProfilePage })));
const RosterPage = lazy(() => import('./pages/RosterPage').then(m => ({ default: m.RosterPage })));
const RosterDisplayPage = lazy(() => import('./pages/RosterDisplayPage').then(m => ({ default: m.RosterDisplayPage })));
const CalendarPage = lazy(() => import('./pages/CalendarPage').then(m => ({ default: m.CalendarPage })));
const StratbookPage = lazy(() => import('./pages/StratbookPage').then(m => ({ default: m.StratbookPage })));
const StrategyDetailPage = lazy(() => import('./pages/StrategyDetailPage').then(m => ({ default: m.StrategyDetailPage })));
const DryrunStratDetailPage = lazy(() => import('./pages/DryrunStratDetailPage').then(m => ({ default: m.DryrunStratDetailPage })));
const ReplayBuilderPage = lazy(() => import('./pages/ReplayBuilderPage').then(m => ({ default: m.ReplayBuilderPage })));
const SecondScreenPage = lazy(() => import('./pages/SecondScreenPage').then(m => ({ default: m.SecondScreenPage })));
const MatchesPage = lazy(() => import('./pages/MatchesPage').then(m => ({ default: m.MatchesPage })));
const MatchDetailPage = lazy(() => import('./pages/MatchDetailPage').then(m => ({ default: m.MatchDetailPage })));
const TrainingPage = lazy(() => import('./pages/TrainingPage').then(m => ({ default: m.TrainingPage })));
const LeaguePage = lazy(() => import('./pages/LeaguePage').then(m => ({ default: m.LeaguePage })));
const DemoToolPage = lazy(() => import('./pages/DemoToolPage').then(m => ({ default: m.DemoToolPage })));
const LineupsPage = lazy(() => import('./pages/LineupsPage').then(m => ({ default: m.LineupsPage })));
const CalloutsPage = lazy(() => import('./pages/CalloutsPage').then(m => ({ default: m.CalloutsPage })));
const AccountSettingsPage = lazy(() => import('./pages/AccountSettingsPage').then(m => ({ default: m.AccountSettingsPage })));
const PremiumPage = lazy(() => import('./pages/PremiumPage').then(m => ({ default: m.PremiumPage })));
const CheckoutSuccess = lazy(() => import('./pages/CheckoutSuccess').then(m => ({ default: m.CheckoutSuccess })));
const GameServerPage = lazy(() => import('./pages/GameServerPage').then(m => ({ default: m.GameServerPage })));
const PracticeDemoPage = lazy(() => import('./pages/PracticeDemoPage').then(m => ({ default: m.PracticeDemoPage })));
const CommunicationsPage = lazy(() => import('./pages/CommunicationsPage').then(m => ({ default: m.CommunicationsPage })));
const PersonalSpacePage = lazy(() => import('./pages/PersonalSpacePage').then(m => ({ default: m.PersonalSpacePage })));
const AdminRenderJobsPage = lazy(() => import('./pages/admin/AdminRenderJobsPage').then(m => ({ default: m.AdminRenderJobsPage })));
const AdminOverviewPage = lazy(() => import('./pages/admin/AdminOverviewPage').then(m => ({ default: m.AdminOverviewPage })));
const AdminLayout = lazy(() => import('./layouts/AdminLayout').then(m => ({ default: m.AdminLayout })));
const AdminUsersPage = lazy(() => import('./pages/admin/AdminUsersPage').then(m => ({ default: m.AdminUsersPage })));
const AdminTeamsPage = lazy(() => import('./pages/admin/AdminTeamsPage').then(m => ({ default: m.AdminTeamsPage })));
const AdminStoragePage = lazy(() => import('./pages/admin/AdminStoragePage').then(m => ({ default: m.AdminStoragePage })));
const AdminWeeklyRafflePage = lazy(() => import('./pages/admin/AdminWeeklyRafflePage').then(m => ({ default: m.AdminWeeklyRafflePage })));
const StashPage = lazy(() => import('./pages/StashPage').then(m => ({ default: m.StashPage })));
const RafflesPage = lazy(() => import('./pages/RafflesPage').then(m => ({ default: m.RafflesPage })));
const AdminHighlightsPage = lazy(() => import('./pages/admin/AdminHighlightsPage').then(m => ({ default: m.AdminHighlightsPage })));
const AdminServersPage = lazy(() => import('./pages/admin/AdminServersPage').then(m => ({ default: m.AdminServersPage })));
const AdminCustomServersPage = lazy(() => import('./pages/admin/AdminCustomServersPage').then(m => ({ default: m.AdminCustomServersPage })));
const AdminAppServerPage = lazy(() => import('./pages/admin/AdminAppServerPage').then(m => ({ default: m.AdminAppServerPage })));
const AdminPremiumPage = lazy(() => import('./pages/admin/AdminPremiumPage').then(m => ({ default: m.AdminPremiumPage })));
const AdminInboxPage = lazy(() => import('./pages/admin/AdminInboxPage').then(m => ({ default: m.AdminInboxPage })));
const AdminMapGridsPage = lazy(() => import('./pages/admin/AdminMapGridsPage').then(m => ({ default: m.AdminMapGridsPage })));
const AdminMapPoolPage = lazy(() => import('./pages/admin/AdminMapPoolPage').then(m => ({ default: m.AdminMapPoolPage })));
const AdminEseaImportPage = lazy(() => import('./pages/admin/AdminEseaImportPage').then(m => ({ default: m.AdminEseaImportPage })));
const AdminDachImportPage = lazy(() => import('./pages/admin/AdminDachImportPage').then(m => ({ default: m.AdminDachImportPage })));
const AdminBadgesPage = lazy(() => import('./pages/admin/AdminBadgesPage').then(m => ({ default: m.AdminBadgesPage })));
const AdminProDemosPage = lazy(() => import('./pages/admin/AdminProDemosPage').then(m => ({ default: m.AdminProDemosPage })));
const AdminAmateurDemosPage = lazy(() => import('./pages/admin/AdminAmateurDemosPage').then(m => ({ default: m.AdminAmateurDemosPage })));
const AdminMatchAnalyzerPage = lazy(() => import('./pages/admin/AdminMatchAnalyzerPage').then(m => ({ default: m.AdminMatchAnalyzerPage })));
const PracSearchPage = lazy(() => import('./pages/PracSearchPage').then(m => ({ default: m.PracSearchPage })));
const BrowserExtensionPage = lazy(() => import('./pages/BrowserExtensionPage').then(m => ({ default: m.BrowserExtensionPage })));
const ForumPage = lazy(() => import('./pages/ForumPage').then(m => ({ default: m.ForumPage })));
const PostDetailPage = lazy(() => import('./pages/PostDetailPage').then(m => ({ default: m.PostDetailPage })));
const PublicProfilePage = lazy(() => import('./pages/PublicProfilePage').then(m => ({ default: m.PublicProfilePage })));
const PublicTeamProfilePage = lazy(() => import('./pages/PublicTeamProfilePage').then(m => ({ default: m.PublicTeamProfilePage })));
const SharedDemoPage = lazy(() => import('./pages/SharedDemoPage').then(m => ({ default: m.SharedDemoPage })));
const DocumentationPage = lazy(() => import('./pages/DocumentationPage').then(m => ({ default: m.DocumentationPage })));
import MaintenancePage from './pages/MaintenancePage';
import { ServerBlockProvider } from './context/ServerBlockContext';
import { LegalPage } from './pages/LegalPage';
import { ExclusiveLoginPage } from './pages/ExclusiveLoginPage';
import BannedScreen from './pages/BannedScreen';
import axios from 'axios';
import { useSmartPolling } from './hooks/useSmartPolling';
import { WithdrawalPage } from './pages/WithdrawalPage';
const AdminSteamBotPage = lazy(() => import('./pages/admin/AdminSteamBotPage').then(m => ({ default: m.AdminSteamBotPage })));
const AdminWithdrawalsPage = lazy(() => import('./pages/admin/AdminWithdrawalsPage').then(m => ({ default: m.AdminWithdrawalsPage })));

/** Global overlay that covers the ENTIRE screen from the very first render.
 *  Reads sessionStorage synchronously so the black is guaranteed before any
 *  child component (layout, sidebar, header) paints. */
function TunnelTransitionOverlay() {
  const [active] = useState(() => {
    if (sessionStorage.getItem('tunnelOverlayActive') === 'true') {
      return true;
    }
    return false;
  });
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return;
    }
    // Wait for the dashboard content to render behind the overlay, then fade out
    const timer = setTimeout(() => {
      setVisible(false);
      sessionStorage.removeItem('tunnelOverlayActive');
    }, 800);
    return () => clearTimeout(timer);
  }, [active]);

  if (!active) return null;

  return (
    <div
      className="fixed inset-0 pointer-events-none"
      style={{
        zIndex: 9999,
        backgroundColor: '#000',
        opacity: visible ? 1 : 0,
        transition: 'opacity 1.6s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    />
  );
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  if (isLoading) return <div className="min-h-screen bg-slate-950 flex items-center justify-center text-white">Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" />;
  if (user?.isBanned) return <BannedScreen />;
  return children;
}

function RequireTeam() {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="min-h-screen bg-slate-950 flex items-center justify-center text-white">Loading...</div>;

  if (user?.isBanned) return <BannedScreen />;
  if (!user?.teamId) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

import { ThemeProvider } from './context/ThemeContext';
import { GhostChangeTrackerProvider } from './context/GhostChangeTrackerContext';
import { NavigationGuardProvider } from './context/NavigationGuardContext';

/** Bridge component that reads auth state and passes isAdmin to the tracker */
function GhostTrackerBridge({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  return (
    <GhostChangeTrackerProvider isAdmin={!!user?.isAdmin}>
      <NavigationGuardProvider>
        {children}
      </NavigationGuardProvider>
    </GhostChangeTrackerProvider>
  );
}

const MAINT_API = import.meta.env.VITE_API_URL || 'http://localhost:3001';

/** Checks maintenance status; if on + user is not admin, show MaintenancePage */
function MaintenanceGuard({ children }: { children: React.ReactNode }) {
  const { user, isLoading, refreshUser } = useAuth();
  const [maintOn, setMaintOn] = useState(false);
  const [checked, setChecked] = useState(false);

  const check = useCallback(async (signal: AbortSignal) => {
    try {
      const { data } = await axios.get(`${MAINT_API}/maintenance/status`, {
        signal,
        timeout: 8000,
      });
      if (!signal.aborted) setMaintOn(!!data?.enabled);
    } catch (error) {
      if (!signal.aborted) throw error;
    } finally {
      if (!signal.aborted) setChecked(true);
    }
  }, []);

  useSmartPolling(check, {
    intervalMs: 30_000,
    jitterRatio: 0.1,
  });

  if (!checked) return null; // wait for first check

  // Maintenance ON + not logged in or not admin → block
  if (maintOn && !isLoading && !user?.isAdmin) {
    return (
      <MaintenancePage
        onAdminLogin={(token: string) => {
          localStorage.setItem('token', token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          refreshUser();
          setMaintOn(false);
        }}
      />
    );
  }

  return <>{children}</>;
}

import { Toaster } from 'react-hot-toast';

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" containerStyle={{ zIndex: 20000 }} />
      <AuthProvider>
        <EchoImportsProvider>
        <ThemeProvider>
          <ServerBlockProvider>
          <GhostTrackerBridge>
            <TunnelTransitionOverlay />
            <MaintenanceGuard>
              <Suspense fallback={null}>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/imprint" element={<LegalPage />} />
                <Route path="/privacy" element={<LegalPage />} />
                <Route path="/terms" element={<LegalPage />} />
                <Route path="/withdrawal" element={<WithdrawalPage />} />
                <Route path="/oauth-callback" element={<OAuthCallback />} />
                <Route path="/exclusive" element={<ExclusiveLoginPage />} />
                <Route path="/shared-demo" element={<SharedDemoPage />} />
                <Route path="/documentation" element={<DocumentationPage />} />

                <Route path="/" element={
                  <ProtectedRoute>
                    <TeamSelectionPage />
                  </ProtectedRoute>
                } />

                <Route path="/settings" element={
                  <ProtectedRoute>
                    <AccountSettingsPage />
                  </ProtectedRoute>
                } />

                <Route path="/premium" element={
                  <ProtectedRoute>
                    <PremiumPage />
                  </ProtectedRoute>
                } />

                <Route path="/checkout/success" element={
                  <ProtectedRoute>
                    <CheckoutSuccess />
                  </ProtectedRoute>
                } />

                <Route path="/news/:id" element={<ProtectedRoute><NewsPage /></ProtectedRoute>} />
                <Route path="/personal" element={
                  <ProtectedRoute>
                    <PersonalAdminSpace><PersonalSpacePage /></PersonalAdminSpace>
                  </ProtectedRoute>
                } />

                <Route path="/stash" element={<ProtectedRoute><StashPage /></ProtectedRoute>} />
                <Route path="/raffles" element={
                  <ProtectedRoute>
                    <RafflesPage />
                  </ProtectedRoute>
                } />

                <Route path="/admin" element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }>
                  <Route index element={<Navigate to="overview" replace />} />
                  <Route path="overview" element={<AdminOverviewPage />} />
                  <Route path="render-jobs" element={<AdminRenderJobsPage />} />
                  <Route path="users" element={<AdminUsersPage />} />
                  <Route path="teams" element={<AdminTeamsPage />} />
                  <Route path="storage" element={<AdminStoragePage />} />
                  <Route path="steam-bot" element={<AdminSteamBotPage />} />
                  <Route path="weekly-raffle" element={<AdminWeeklyRafflePage />} />
                  {/* Legacy redirect — the Leaderboards tab became Weekly Raffle */}
                  <Route path="leaderboards" element={<Navigate to="/admin/weekly-raffle" replace />} />
                  <Route path="highlights" element={<AdminHighlightsPage />} />
                  <Route path="news" element={<AdminNewsPage />} />
                  <Route path="game-servers" element={<AdminServersPage />} />
                  <Route path="custom-servers" element={<AdminCustomServersPage />} />
                  <Route path="app-server" element={<AdminAppServerPage />} />
                  {/* Legacy redirect */}
                  <Route path="servers" element={<Navigate to="/admin/game-servers" replace />} />
                  <Route path="premium" element={<AdminPremiumPage />} />
                  <Route path="withdrawals" element={<AdminWithdrawalsPage />} />
                  <Route path="inbox" element={<AdminInboxPage />} />
                  <Route path="map-pool" element={<AdminMapPoolPage />} />
                  <Route path="map-grids" element={<AdminMapGridsPage />} />
                  <Route path="esea-import" element={<AdminEseaImportPage />} />
                  <Route path="dach-import" element={<AdminDachImportPage />} />
                  <Route path="badges" element={<AdminBadgesPage />} />
                  <Route path="pro-demos" element={<AdminProDemosPage />} />
                  <Route path="pro-recent-replay" element={<DemoToolPage mode="personal" />} />
                  <Route path="amateur-demos" element={<AdminAmateurDemosPage />} />
                  <Route path="match-analyzer" element={<AdminMatchAnalyzerPage />} />
                  <Route path="strategies" element={<StratbookPage adminGlobal />} />
                  <Route path="strategies/:id" element={<StrategyDetailPage globalArchive globalAdmin />} />
                  <Route path="strategies/:id/dryrun" element={<DryrunStratDetailPage globalArchive globalAdmin />} />
                  <Route path="lineups" element={<div className="h-[calc(100vh-80px)] w-full"><LineupsPage key="admin-stratsync" mode="admin-stratsync" /></div>} />
                </Route>

                <Route path="/browser-extension" element={
                  <ProtectedRoute>
                    <BrowserExtensionPage />
                  </ProtectedRoute>
                } />

                <Route path="/forum" element={
                  <ProtectedRoute>
                    <ForumPage />
                  </ProtectedRoute>
                } />
                
                <Route path="/forum/post/:postId" element={
                  <ProtectedRoute>
                    <PostDetailPage />
                  </ProtectedRoute>
                } />

                <Route path="/profile/:userId" element={
                  <ProtectedRoute>
                    <PublicProfilePage />
                  </ProtectedRoute>
                } />

                <Route path="/team-profile/:id" element={
                  <ProtectedRoute>
                    <PublicTeamProfilePage />
                  </ProtectedRoute>
                } />

                <Route path="/team/:teamId" element={
                  <ProtectedRoute>
                    <RequireTeam />
                  </ProtectedRoute>
                }>
                  <Route element={<MainLayout />}>
                    <Route path="dashboard" element={<DashboardPage />} />
                    <Route path="communications" element={<CommunicationsPage />} />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="profile/:userId" element={<ProfilePage />} />
                    <Route path="roster" element={<RosterPage />} />
                    <Route path="roster-display" element={<RosterDisplayPage />} />
                    <Route path="calendar" element={<CalendarPage />} />
                    <Route path="stratbook" element={<StratbookPage />} />
                    <Route path="stratbook/replay-builder" element={<ReplayBuilderPage />} />
                    <Route path="stratbook/:id/builder" element={<ReplayBuilderPage />} />
                    <Route path="stratbook/global/:id" element={<StrategyDetailPage globalArchive />} />
                    <Route path="stratbook/global/:id/dryrun" element={<DryrunStratDetailPage globalArchive />} />
                    <Route path="stratbook/:id" element={<StrategyDetailPage />} />
                    <Route path="stratbook/:id/dryrun" element={<DryrunStratDetailPage />} />
                    <Route path="second-screen" element={<SecondScreenPage />} />
                    <Route path="lineups" element={<LineupsPage key="team" mode="team" />} />
                    <Route path="stratsync-lineups" element={<LineupsPage key="stratsync" mode="stratsync" />} />
                    <Route path="callouts" element={<CalloutsPage />} />
                    <Route path="matches" element={<MatchesPage />} />
                    <Route path="matches/:id" element={<MatchDetailPage />} />
                    <Route path="practice" element={<TrainingPage />} />
                    <Route path="leagues" element={<LeaguePage />} />
                    <Route path="demo-tool" element={<DemoToolPage />} />
                    <Route path="practice-demo/:id" element={<PracticeDemoPage />} />
                    <Route path="game-server" element={<GameServerPage />} />
                    <Route path="scout" element={<ScoutPage />} />
                    <Route path="pros" element={<ProsPage />} />
                    <Route path="prac-search" element={<PracSearchPage />} />
                  </Route>
                </Route>

                {/* Catch-all redirect to handle legacy routes and invalid paths */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
            </MaintenanceGuard>
          </GhostTrackerBridge>
          </ServerBlockProvider>
        </ThemeProvider>
        </EchoImportsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
